module.exports = __webpack_public_path__ + "static/img/icon_weixin_pay.657e3c8d.png";